/* global window */
/* eslint no-use-before-define: ["error", { "functions": false }] */
import iframeBridge from './iframe-bridge';

/**
 * Determines whether the app bridge is set in the global scope and
 * whether the component should bypass the viewManager for the app
 *
 * @param {HTMLNode} rootElement The element to attach events to
 * @return {Boolean}
 */
export function isEnabled(rootElement) {
  const root = iframeBridge.getRoot(window);

  if (!isAppEnabled(root)) {
    return false;
  }

  if (getType(rootElement) !== 'video') {
    return false;
  }

  return true;
}

/**
 * Returns the role-based views, filtering out the roadblock views for the app.
 * Roles include `sep-expired` which indicates the users EU portability status
 * has flagged as failed or expired by the de-auth token endpoint.
 *
 * @param {Object} templates The templates used by the ViewManager
 * @return {Array}
 */
export function getAppRoles(templates) {
  const roles = [];
  Object.keys(templates).forEach((key) => {
    if (key === 'default' || key === 'loggedin' || key === 'sep-expired') {
      return;
    }

    roles.push(key);
  });

  return roles;
}

/**
 * Determines whether SKY_SPORTS_APP, appWrapper or AndroidApp
 * is present in the global scope
 *
 * @param {Object} root The window object to assess
 * @return {Boolean}
 */
function isAppEnabled(root) {
  if (isSkySportsApp(root) || isAppWrapper(root) || isAndroidApp(root)) {
    return true;
  }

  return false;
}

/**
 * Determines whether SKY_SPORTS_APP is present
 * in the global scope
 *
 * @param {Object} root The window object to assess
 * @return {Boolean}
 */
function isSkySportsApp(root) {
  return typeof root.SKY_SPORTS_APP !== 'undefined';
}

/**
 * Determines whether appWrapper is present
 * in the global scope
 *
 * @param {Object} root The window object to assess
 * @return {Boolean}
 */
function isAppWrapper(root) {
  return typeof root.appWrapper !== 'undefined';
}

/**
 * Determines whether AndroidApp is present
 * in the global scope
 *
 * @param {Object} root The window object to assess
 * @return {Boolean}
 */
function isAndroidApp(root) {
  return typeof root.AndroidApp !== 'undefined';
}

/**
 * Returns the Type value
 *
 * @param {HTMLNode} rootElement The element to get the data from
 * @return {String}
 */
function getType(rootElement) {
  return rootElement.getAttribute('data-type');
}
